import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProcessResultInformationData } from 'appEntries/panel/classes';
import { DialogActionsEnum, DialogComponent } from 'appShared/components';

@Component({
  selector: 'app-process-result-information',
  templateUrl: './process-result-information.component.html',
  styleUrls: ['./process-result-information.component.scss']
})
export class ProcessResultInformationComponent extends DialogComponent<ProcessResultInformationComponent> {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            informationData: ProcessResultInformationData
        },
        public dialogRef: MatDialogRef<ProcessResultInformationComponent>,
    ) {
        super(dialogRef);

        this.config = data.informationData.getConfig();
    }

    onActionButtonClicked(action: number): void {
        switch (action) {
            case DialogActionsEnum.Decline:
                this.dialogRef.close(false);
                break;
            case DialogActionsEnum.Confirm:
                this.dialogRef.close(true);
                break;
            default:
                this.dialogRef.close(false);
        }
    }
}
